var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDefaultVideo = function SvgDefaultVideo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#5ABFF2",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 7.875C3 6.839 3.84 6 4.875 6h6.313c1.035 0 1.874.84 1.874 1.875v5c0 1.036-.839 1.875-1.874 1.875H4.875A1.875 1.875 0 0 1 3 12.875zM14.375 8.446l1.746-1.336a.547.547 0 0 1 .879.435v5.495c0 .48-.575.727-.923.396l-1.702-1.615z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDefaultVideo);
export { ForwardRef as Icon };
export default "img/element-icons/room/default_video.f29df7d.svg";